export default __webpack_public_path__ + "static/media/green3-big.a038aadc.png";